module.exports = __webpack_public_path__ + "img/360-konferensrum-1 2.408f67d1.jpg";